export default __webpack_public_path__ + "static/media/icone-meus-conteudos-hover.3b00e43d.svg";